import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { code } from '@api/axiosAPI';

const TestDetailTemplate = () => {
  const navigate = useNavigate();
  const { parComCd } = useParams();

  const { isLoading, data, error } = code.getComCdByParComCd(['getComCdByParComCd', ['test']], { enabled: true, staleTime: 0, cacheTime: 0 }, parComCd);

  if (isLoading) return <div>loading...</div>;

  if (error) return <div>erro...</div>;

  return (
    <div>
      <button type="button" onClick={() => navigate(-1)}>
        {' '}
        뒤로가기..
      </button>
      {data.map((e) => {
        return (
          <div key={e.comCd}>
            {e.comCd} :: {e.comCdNm}
          </div>
        );
      })}
    </div>
  );
};

export default TestDetailTemplate;
